
<script>
  export let copy
  export let image
  export let title
</script>


<div class="w-1/3 p-2">
  <h1 class="text-center font-bold text-lg">{title}</h1>
  <img class="cursor-pointer" src={image} alt="call to action"/>
  <p class="text-center font-bold text-lg">{copy}</p>
</div>